class CustomEvents {
      constructor(){
        this.init();
      }

      shopifyPublishEvent = (payload) => {
        Shopify.analytics.publish('custom_event',payload)
      };

      replacementPartEvent = (event) =>{
        // Shopify.analytics.publish('replacement_part_view',data)
        const replacementPartData = document.getElementById('replacementPartData');
        if(!replacementPartData) return;
        const data = JSON.parse(replacementPartData.textContent);
        const payload = {
            event: event,
            original_part: data?.originalPart,
            replacement_part: data?.replacementPart,
            product_name: data?.productName,
            page_path: data?.pagePath,
            page_title: data?.pageTitle
        };
        this.shopifyPublishEvent(payload)
    }

    replacementTextClick = () =>{
        this.replacementPartEvent('replacement_part_click');
    }

    replacementPartView = () =>{
        this.replacementPartEvent('replacement_part_view');
    }

    clickEvents = () =>{
       let replacementText = document.querySelectorAll('.replacement-text-js');
       if(!replacementText) return;
        replacementText.forEach(text => {
            text.addEventListener('click', this.replacementTextClick);
       });
    }

    getProductName = () =>{
      return document.querySelector('h1.product-name')?.textContent
        ?.trim()
        ?.replace(/\s+/g, ' ') || '';
    }

    productDescriptionInteraction = (clickText) =>{
      const payload = {
        event: 'product_description_interaction',
        click_text: String(clickText || '').trim().replace(/\s+/g, ' '),
        product_name: this.getProductName(),
        page_path: window.location.pathname,
        page_title: document.title
      };

      this.shopifyPublishEvent(payload);
    }

    productDescriptionEvents = () =>{
      document.addEventListener('click', (event) => {
        const tab = event.target.closest(
          '.estimate-compatible-tabs .tab-btn-comp, ' +
          '.product-tabs.desktop-tabs .tab-btn, ' +
          '.product-tabs.desktop-tabs .compatible-tab, ' +
          '.pdp-page-ds .pdesc .PDPDESC, ' +
          '.pdp-page-ds .rtnpolicypdp .PDPDESC'
        );

        if (!tab) return;
        this.productDescriptionInteraction(tab.textContent);
      });
    }

    modelCompatibilityCheck = (model, clickText = 'check') =>{
      const normalizedModel = String(model || '').trim().toUpperCase();
      if (!normalizedModel) return;

      const payload = {
        event: 'model_compatibility_check',
        click_text: String(clickText),
        model: normalizedModel,
        page_path: window.location.pathname,
        page_title: document.title
      };

      this.shopifyPublishEvent(payload);
    }

    addToCartEvents = (lineItem, addToCartFrom = 'pdp_normal_button') =>{
      if (!lineItem) return;

      const variant = lineItem.merchandise || {};
      const product = variant.product || {};
      const quantity = Number.parseInt(lineItem.quantity, 10) || 1;
      const hasPixelPrice = variant.price?.amount != null;
      const price = hasPixelPrice
        ? Number.parseFloat(variant.price.amount) || 0
        : (Number.parseFloat(lineItem.final_price ?? lineItem.price) || 0) / 100;
      const currency = String(
        variant.price?.currencyCode ||
        window.Shopify?.currency?.active ||
        'USD'
      );
      const properties = lineItem.properties || {};
      const isReplacement = Boolean(
        document.getElementById('replacementPartData')
      );
      const addToCartSource =
        String(properties._add_to_cart_source || '').toLowerCase() === 'replacement' ||
        isReplacement
          ? 'replacement'
          : 'NA';
      const productId = product.id || lineItem.product_id || '';
      const variantId = variant.id || lineItem.variant_id || lineItem.id || '';
      const sku = String(variant.sku || lineItem.sku || variantId);

      const payload = {
        event: 'add_to_cart',
        add_to_cart_source: window?.add_to_cart_source || addToCartSource,
        add_to_cart_from: addToCartFrom,
        client_id: lineItem.clientId || '',
        timestamp: new Date().toISOString(),
        page_title: document.title,
        page_location: window.location.href,
        page_path: window.location.pathname,
        ecommerce: {
          currency,
          value: price * quantity,
          items: [{
            id: `shopify_${window.Shopify?.country || ''}_${productId}_${variantId}`,
            item_id: sku,
            item_name: String(product.title || lineItem.product_title || ''),
            item_category: String(product.type || lineItem.product_type || ''),
            item_brand: String(product.vendor || lineItem.vendor || ''),
            item_variant: String(variant.title || lineItem.variant_title || ''),
            price,
            quantity,
            currency
          }],
          skus: [sku]
        }
      };

      this.shopifyPublishEvent(payload);
    }

    init = () =>{
        this.replacementPartView();
        this.clickEvents();
        this.productDescriptionEvents();
    }
}


window.customEvents = new CustomEvents();
